import { Vector3 } from 'three';
import { ActionControllerEventName, Tween, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { PickingControllerEvents } from '@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController';
import { PreparationPickingObjects } from "../../utils/PreparationPickingObjects";
export default class FunnelModule extends ViewerModule {
    constructor(model, table, uiContainer, level) {
        super();
        this.level = level;
        this.funnelTablePosition = new Vector3(23.35, -18.6, -7.64);
        this.uiObject.name = 'FunnelModule';
        this.model = model;
        this.table = table;
        this.level = level;
        this.defaultPosition = model.position.clone();
        // this.addObject(this.uiContainer = uiContainer);
        this.uiContainer = uiContainer;
    }
    initWaitSelect() {
        this.actionController.once(ActionControllerEventName.click, this.model, () => {
            if (Viewer.controls.zController)
                return;
            Viewer.pointerController.setObject(this.model);
            this.visibilityShadow(false);
            this.fire('selected');
        });
        if (this.level.lobby.app.zSpacePickingController) {
            PreparationPickingObjects.saveObjectState(this.model);
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.PICKED, this.model, () => {
                if (!this.level.interaction)
                    return;
                Viewer.scene.add(this.model);
                this.visibilityShadow(false);
                this.fire('selected');
            });
        }
    }
    visibilityShadow(visibility = true) {
        const pPlane = this.model.getObjectByName('pPlane');
        if (pPlane)
            pPlane.visible = visibility;
    }
    setDefaultPositionRotation() {
        Viewer.pointerController.setObject(null);
        this.visibilityShadow(true);
        this.table.add(this.model);
        this.model.position.copy(this.defaultPosition);
        this.model.rotation.set(0, 0, 0);
    }
    putInFlask() {
        if (Viewer.controls.zController)
            this.model.rotation.set(0, 0, Math.PI);
        this.model.position.set(-0.3, 5.5, 1.55);
        this.flyTo(new Vector3(-0.3, 5.1, 1.55));
    }
    initWaitApply() {
        this.actionController.once(ActionControllerEventName.click, this.model, () => {
            if (Viewer.controls.zController)
                return;
            this.fire('applied');
        });
    }
    flyTo(pos, time = 1000, onComplete) {
        new Tween(this.model.position)
            .to(pos.clone(), time)
            .easing(TWEEN.Easing.Linear.None)
            .onComplete(() => onComplete && onComplete())
            .start();
    }
    show(isVisible = true) {
        this.uiObject.visible = isVisible;
    }
}
